import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { CheckCircle, XCircle, Home, Calendar } from 'lucide-react';

const PaymentStatus = () => {
    const [searchParams] = useSearchParams();
    const [status, setStatus] = useState(null);
    const [message, setMessage] = useState('');

    useEffect(() => {
        const statusParam = searchParams.get('status');
        const messageParam = searchParams.get('message');
        setStatus(statusParam);
        setMessage(messageParam);
    }, [searchParams]);

    if (!status) return <div className="container py-5 text-center">Yükleniyor...</div>;

    return (
        <div className="container py-5 min-vh-100 d-flex align-items-center justify-content-center">
            <div className="card shadow-lg border-0 rounded-4 p-5 text-center" style={{ maxWidth: '600px', width: '100%' }}>
                {status === 'success' ? (
                    <div className="animate__animated animate__fadeIn">
                        <CheckCircle size={80} className="text-success mb-4" />
                        <h1 className="fw-bold mb-3">Ödeme Başarılı!</h1>
                        <p className="text-muted fs-5 mb-4">
                            Rezervasyonunuz başarıyla onaylandı. Halı sahada görüşmek üzere!
                        </p>
                        <div className="bg-light p-3 rounded-3 mb-4">
                            <small className="text-muted d-block">Ödeme Numarası:</small>
                            <code className="fw-bold text-dark">{searchParams.get('paymentId')}</code>
                        </div>
                    </div>
                ) : (
                    <div className="animate__animated animate__fadeIn">
                        <XCircle size={80} className="text-danger mb-4" />
                        <h1 className="fw-bold mb-3">Ödeme Başarısız</h1>
                        <p className="text-muted fs-5 mb-4">
                            {message || 'Ödeme işlemi sırasında bir hata oluştu. Lütfen tekrar deneyin.'}
                        </p>
                    </div>
                )}

                <div className="d-flex gap-3 justify-content-center">
                    <Link to="/" className="btn btn-outline-dark px-4 py-2 rounded-3 d-flex align-items-center gap-2">
                        <Home size={18} /> Ana Sayfa
                    </Link>
                    {status !== 'success' && (
                        <Link to="/reservation" className="btn btn-warning px-4 py-2 rounded-3 d-flex align-items-center gap-2 fw-bold">
                            <Calendar size={18} /> Tekrar Dene
                        </Link>
                    )}
                </div>
            </div>
        </div>
    );
};

export default PaymentStatus;
